/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Table,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { callAPI } from 'lorautils/api';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import SearchInput from 'loracoms/SearchInput';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import styles from './styles.scss';

const propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onChoose: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  checkedId: PropTypes.array,
};

const defaultProps = {
  checkedId: [],
};

class DeviceModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checked: [],
      checkedId: props.checkedId,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.mark = '';
    this.q = null;
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, checkedId } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (checkedId !== this.props.checkedId) {
      this.setState({ checkedId });
    }
  }

  componentWillUnmount() {
    this.loadData = null;
  }

  loadData() {
    const { appId } = this.props;
    callAPI({
      endpoint: '/lora/nodes',
      query: {
        app: appId,
        pageSize: 10,
        q: this.q,
        mark: this.mark,
      },
    }).then((data) => {
      const { list, more, mark } = data;
      this.setState({
        lists: list,
        status: 'success',
        more,
        mark,
        noData: list.length === 0,
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  handleSearch(e) {
    const search = e.target.value;
    this.setState({
      search,
      reset: new Date(),
    });
    this.mark = '';

    if (search.length > 0) {
      const s = search.replace(/[:-]/g, '');
      this.q = `or,name:*${s}*,deveui:*${s}*,devaddr:*${s}*,appIdeui:${s}*,city:*${s}*,area:*${s}*,band:*${s}*`;
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  }

  handleSubmit() {
    const { onHide, onChoose } = this.props;
    const { checked, checkedId } = this.state;
    onHide();
    if (!checked || checked.length === 0) {
      return;
    }
    onChoose(checked, checkedId);
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, () => {
      this.loadData();
    });
  }

  handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  }

  handleChecked(e, device) {
    this.setState({ checked: [device], checkedId: [device.id] });
  }

  handleCancel() {
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, () => {
      this.loadData();
    });
    this.props.onHide();
    this.setState({ checked: [], checkedId: [] });
  }

  renderTbody() {
    const { lists, checkedId } = this.state;
    const rows = _.map(lists, (item) => {
      const isChecked = checkedId[0] ? item.id === checkedId[0] : false;
      const radio = (
        <input
          id={item.id}
          type="radio"
          name="deveui"
          onChange={e => this.handleChecked(e, item)}
          checked={isChecked}
        />
      );
      return (
        <tr key={item.id}>
          <td>
            <div className={styles.checkbox}>
              {radio}
              <label htmlFor={item.id} />
            </div>
          </td>
          <td key={`${item.id}-${item.name}`}>{item.name}</td>
          <td key={`${item.id}-${item.deveui}`}>{item.deveui}</td>
          <td>{format(item.createdAt, 'YYYY-MM-DD HH:mm:ss')}</td>
        </tr>
      );
    });
    return rows;
  }

  render() {
    const { showModal,
      search = '',
      mark = '',
      more = false,
      reset,
      status,
      noData = false,
    } = this.state;
    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-light"
      >
        <Modal.Header>
          <SearchInput
            onChange={this.handleSearch}
            value={search}
            placeholder={this.intlMsg.msg('search.placeholder')}
          />
        </Modal.Header>
        <Modal.Body className="clearfix">
          <Table
            className="aisz-table-light" striped hover bordered responsive
          >
            <thead>
              <tr>
                <th />
                <th>{this.intlMsg.msg('addmodal.name')}</th>
                <th>{this.intlMsg.msg('addmodal.deveui')}</th>
                <th>{this.intlMsg.msg('addmodal.createdAt')}</th>
              </tr>
            </thead>
            <tbody>
              {this.renderTbody()}
            </tbody>
          </Table>
          <ShowIf if={noData}>
            <div className="text-center">
              {this.intlMsg.msg('adddevice.nodata')}
            </div>
          </ShowIf>
          <div className="pull-right">
            <TablePager
              status={status}
              mark={mark}
              more={more}
              onPrev={this.handleChangeMark}
              onNext={this.handleChangeMark}
              reset={reset}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.handleSubmit()}
          >
            {this.intlMsg.msg('confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            onClick={() => this.handleCancel()}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DeviceModal.propTypes = propTypes;
DeviceModal.defaultProps = defaultProps;

export default connect(null,
  null,
)(injectIntl(CSSModules(DeviceModal,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DeviceModal/index.jsx